import { generateClient } from 'aws-amplify/api';
import Vue from 'vue';
import * as qlqueries from '../graphql/queries';
import * as qlmutations from '../graphql/mutations';
import * as customQueries from '../graphql/customQueries';
import * as customMutations from '../graphql/customMutations';

const client = generateClient();
const graphqlOperation = (query, variables) => ({ query, variables });

const state = {
  name: 'Stream',
  logs: {},
  streamDestinations: null,
  streamSources: null,
  streamTypes: [
    'SRT',
    'UDP',
    'RIST',
    'RTMP',
    'HLS',
    'DASH',
  ],
  encryptionTypes: [
    'NONE',
    'AES128',
    'AES256',
  ],
  loading: false,
};

const getters = {
};

const mutations = {
  setList: (state, payload) => {
    Vue.set(state, payload.property, payload.data.items);
  },

  setLoading: (state, payload) => {
    Vue.set(state, 'loading', payload);
  },
};

const actions = {
  async listStreamDestinations({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listStreamDestinations,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listStreamDestinations, property: 'streamDestinations' });
      return data.listStreamDestinations;
    } catch (error) {
      const hasData = !!error.data && !!error.data.listStreamDestinations;
      if (hasData) {
        const { data } = error;
        commit('setList', { data: data.listStreamDestinations, property: 'streamDestinations' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the INPUTS' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t list stream destinations' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listStreamSources({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listStreamSources,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listStreamSources, property: 'streamSources' });
      return data.listStreamSources;
    } catch (error) {
      const hasData = !!error.data && !!error.data.listStreamSources;
      if (hasData) {
        const { data } = error;
        commit('setList', { data: data.listStreamSources, property: 'streamSources' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the INPUTS' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t list stream sources' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createStreamDestination({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createStreamDestination,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Stream Destination created' });
      return data.createStreamDestination;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createStreamSource({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createStreamSource,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Stream Source created' });
      return data.createStreamSource;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteStreamDestination({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteStreamDestination,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Stream destination deleted' });
      return data.deleteStreamDestination;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteStreamSource({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteStreamSource,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Stream source deleted' });
      return data.deleteStreamSource;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateStreamSource({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateStreamSource,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateStreamSource, property: 'source' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateStreamSource;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateStreamDestination({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateStreamDestination,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateStreamDestination, property: 'destination' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateStreamDestination;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  // Stream Router Interface Actions
  async listStreamRouterInterfacesConnections({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customQueries.listStreamRouterInterfacesConnections, payload),
      );
      return result.data.listStreamRouterInterfacesConnections;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to load stream router interface connections' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async getStreamRouterInterfaceConnections({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customQueries.getStreamRouterInterfaceConnections, payload),
      );
      return result.data.getStreamRouterInterfaceConnections;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to load stream router interface connections' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listStreamRouterInterfaces({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customQueries.listStreamRouterInterfaces, payload),
      );
      const response = result.data.listStreamRouterInterfaces;
      
      // Parse the dataJson to extract interfaces
      if (response.success && response.dataJson) {
        try {
          const parsedData = JSON.parse(response.dataJson);
          // Extract interfaces array from the parsed data
          const interfaces = parsedData.interfaces || [];
          
          // Return the response with parsed interfaces for easier consumption
          return {
            ...response,
            interfaces: interfaces,
            parsedData: parsedData
          };
        } catch (parseError) {
          console.error('Failed to parse dataJson for stream router interfaces:', parseError);
          this._vm.$message.error({ message: 'Failed to parse stream router interfaces data' });
          return { 
            error: true, 
            message: 'Failed to parse response data',
            originalResponse: response 
          };
        }
      }
      
      return response;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to load stream router interfaces' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async getStreamRouterInterface({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customQueries.getStreamRouterInterface, payload),
      );
      return result.data.getStreamRouterInterface;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to load stream router interface' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async getStreamRouterInterfaceStatus({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customQueries.getStreamRouterInterfaceStatus, payload),
      );
      return result.data.getStreamRouterInterfaceStatus;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to load stream router interface status' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createStreamRouterInterface({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customMutations.createStreamRouterInterface, payload),
      );
      this._vm.$message({ message: 'Stream router interface created successfully' });
      return result.data.createStreamRouterInterface;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to create stream router interface' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateStreamRouterInterface({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customMutations.updateStreamRouterInterface, payload),
      );
      this._vm.$message({ message: 'Stream router interface updated successfully' });
      return result.data.updateStreamRouterInterface;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to update stream router interface' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteStreamRouterInterface({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customMutations.deleteStreamRouterInterface, payload),
      );
      this._vm.$message({ message: 'Stream router interface deleted successfully' });
      return result.data.deleteStreamRouterInterface;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to delete stream router interface' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  // Wowza Actions
  async listWowzaApplications({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customQueries.listWowzaApplications, payload),
      );
      return result.data.listWowzaApplications;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to load Wowza applications' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async getWowzaApplication({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customQueries.getWowzaApplication, payload),
      );
      return result.data.getWowzaApplication;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to load Wowza application' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listWowzaAppTargets({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customQueries.listWowzaAppTargets, payload),
      );
      return result.data.listWowzaAppTargets;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to load Wowza application targets' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async getWowzaAppTarget({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customQueries.getWowzaAppTarget, payload),
      );
      return result.data.getWowzaAppTarget;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to load Wowza application target' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createExternalWowzaTarget({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customMutations.createExternalWowzaTarget, payload),
      );
      this._vm.$message({ message: 'Wowza target created successfully' });
      return result.data.createExternalWowzaTarget;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to create Wowza target' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateExternalWowzaTarget({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customMutations.updateExternalWowzaTarget, payload),
      );
      this._vm.$message({ message: 'Wowza target updated successfully' });
      return result.data.updateExternalWowzaTarget;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to update Wowza target' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteExternalWowzaTarget({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(customMutations.deleteExternalWowzaTarget, payload),
      );
      this._vm.$message({ message: 'Wowza target deleted successfully' });
      return result.data.deleteExternalWowzaTarget;
    } catch (error) {
      this._vm.$message.error({ message: 'Failed to delete Wowza target' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
